// tslint:disable max-line-length
import * as React from 'react';
import { UiState } from './types';
import { OverlayComponent } from 'app/components';
import styles from './form-context.scss';

export interface FormProps {
  translation: {submit: string, cancel: string, overlay_text: string};
  submit: () => any;
  cancel: () => any;
}

export const FormContext: React.SFC<FormProps & UiState> = ({
  editing,
  translation: text,
  children,
  cancel,
  submit
}) => {

  return (
    <OverlayComponent
      displayOverlay={editing.submitting}
      overlayText={text.overlay_text}
    >
      <div className={styles.formContent}>
        <div className={styles.formBody}>
          <form key={'form-context-form'} noValidate>
            {children}
          </form>
        </div>
      </div>
    </OverlayComponent>
  );
};
